interface travelMode {
  value: number;
  title: string;
}

// export const listOfTravelModes: travelMode[] = [
//   { value: 19, title: 'Car (alone)' },
//   { value: 1, title: 'Walk/run' },
//   { value: 2, title: 'Cycle' },
//   { value: 3, title: 'E Scooter' },
//   { value: 10, title: 'Work shuttle Bus' },
//   { value: 12, title: 'Bus' },
//   { value: 18, title: 'Park and Ride' },
//   { value: 5, title: 'Train' },
//   { value: 14, title: 'Motorcycle/Moped' },
//   { value: 8, title: 'Car Share' },
//   { value: 9, title: 'Car Share (electric)' },
//   { value: 20, title: 'Car (alone) (electric)' },
//   { value: 16, title: 'Taxi' },
//   { value: 0, title: 'Worked from home' },
//   { value: 6, title: 'Van Share' },
//   { value: 7, title: 'Van Share (electric)' },
//   { value: 11, title: 'Work shuttle Bus (electric)' },
//   { value: 15, title: 'Motorcycle/Moped (electric)' },
//   { value: 4, title: 'Tram' },
// ];

export const listOfTravelModes: travelMode[] = [
  { value: 0, title: 'I always work from home' },
  { value: 1, title: 'Walk/Wheel' },
  { value: 23, title: 'Run' },
  { value: 2, title: 'Cycle' },
  { value: 12, title: 'Drive alone' },
  { value: 13, title: 'Drive alone (EV)' },
  { value: 4, title: 'Bus' },
  { value: 5, title: 'Bus (EV)' },
  { value: 9, title: 'Car share' },
  { value: 10, title: 'Car share (EV)' },
  { value: 7, title: 'Train' },
  { value: 8, title: 'Motorcycle/Moped' },
  { value: 22, title: 'Motorcycle/Moped (EV)' },
  { value: 11, title: 'Park and ride' },
  { value: 3, title: 'Electric scooter/Electric bike' },
  { value: 6, title: 'Light rail' },
  { value: 20, title: 'Work shuttle bus' },
  { value: 21, title: 'Work shuttle bus (EV)' },
  { value: 14, title: 'Taxi' },
  { value: 15, title: 'Taxi (EV)' },
  { value: 18, title: 'Van pool' },
  { value: 19, title: 'Van pool (EV)' },
  { value: 16, title: 'Fly' },
  { value: 24, title: 'Tube' },
  { value: 25, title: 'Metro' },
  { value: 26, title: 'Tram' },
  { value: 27, title: 'Hybrid' },
  { value: 28, title: 'Hybrid Carshare' },
  { value: 17, title: 'Other' },
];